import { render, staticRenderFns } from "./options.vue?vue&type=template&id=47c96450&scoped=true"
import script from "./options.vue?vue&type=script&lang=js"
export * from "./options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c96450",
  null
  
)

export default component.exports